import axios from 'axios'
import { baseUrl } from '../constants'
const URL = baseUrl

//for sending the token
const config = (token) => { return { 
    withCredentials: true,
    headers: { Authorization: `Bearer ${token}`, }, 
}}

const createConversation = async (data, token) => {
    const response = await axios.post(URL+'/api/conversations/createConversation', data, config(token))
    return response.data
}

const deleteConversation = async (conversationID, token) => {
    const response = await axios.post(URL+'/api/conversations/deleteConversation', conversationID, config(token))
    return response.data
}//if I delete a converation, it sould only be deleted from my side, the other user should still see 

const searchUsers = async (data, token) => {
    const response = await axios.post(URL+'/api/conversations/searchUsers', data, config(token))
    return response.data
}


const getChurchMembers = async (data, token) => {
    const response = await axios.post(URL+'/api/conversations/getChurchMembers', data, config(token))
    return response.data
}

const searchMembers = async (data, token) => {
    const response = await axios.post(URL+'/api/conversations/searchMembers', data, config(token))
    return response.data
}

const cleanupConversations = async (data, token) => {
    const response = await axios.post(URL+'/api/conversations/cleanupConversations', data, config(token))
    return response.data
}

const markConversationAsRead = async (conversationId, token) => {
    const response = await axios.post(URL+'/api/conversations/markConversationAsRead', conversationId, config(token))
    return response.data
}

const sendPrayselyMessage = async (data, token) => {
    const response = await axios.post(URL+'/api/conversations/sendPrayselyMessage', data, config(token))
    return response.data
}   

const getPrayselyConversations = async (data, token) => {
    const response = await axios.post(URL+'/api/conversations/getPrayselyConversations', data, config(token))
    return response.data
}   


const sendMessageWithConvId = async (data, token) => {
    const response = await axios.post(URL+'/api/messages/sendPrayselyMessageWithConvId', data, config(token))
    return response.data
}

const getMessages = async (conversationId, token) => {
    const response = await axios.post(URL+'/api/messages/getMessages', { conversationId }, config(token))
    return response.data
}

const deleteMessage = async (data, token) => {
    const response = await axios.post(URL+'/api/messages/deleteMessage', data, config(token))
    return response.data
}//if I delete a converation, it sould only be deleted from my side, the other user should still see 

const addNewMessageNotification = async (data, token) => {
    const response = await axios.post(URL+'/api/messages/addNewMessageNotification', data, config(token))
    return response.data
}

const conversationService = { 
    createConversation, getPrayselyConversations, deleteConversation, searchUsers, sendPrayselyMessage,
    getChurchMembers, searchMembers, cleanupConversations, markConversationAsRead,
    sendMessageWithConvId,
    getMessages,
    deleteMessage,
    addNewMessageNotification
}
export default conversationService
